import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { apiRoutes } from '../../../../routes/api/apiRoutes';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';
import { toast } from 'react-toastify';

const EditService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ title: '', description: '', icon: null, icon_url: '' });
  const [isSet, setIsSet] = useState(false);

  const [res, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI("get", `${apiRoutes.admin.services}/${id}`);
  }, []);

  useEffect(() => {
    if (res?.data && !isSet) {
      setData({ ...res.data });
      setIsSet(true);
    }
  }, [res]);

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(data).forEach(([k, v]) => formData.append(k, v));
    formData.append("_method", "PUT");
    if (data.icon) formData.append("icon", data.icon);
    callAPI("post", `${apiRoutes.admin.services}/${id}`, formData);
  };

  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Service updated!");
      setTimeout(() => navigate(uiRoutes.admin.services.list), 1000);
    }
  }, [statusCode]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading title="Edit Service" subTitle="Update your service info" />
          <div className="card p-4 mt-4 shadow-sm">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  className="form-control"
                  value={data.title}
                  onChange={(e) => setData({ ...data, title: e.target.value })}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  value={data.description}
                  onChange={(e) => setData({ ...data, description: e.target.value })}
                  rows="4"
                ></textarea>
              </div>

              <div className="mb-3">
                <label className="form-label">Change Icon</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setData({ ...data, icon: e.target.files[0] })}
                />
                {data.icon_url && (
                  <img
                    src={data.icon_url}
                    alt="Preview"
                    className="mt-3"
                    style={{ height: 80, width: 80, objectFit: 'contain' }}
                  />
                )}
              </div>

              <button type="submit" className="btn btn-primary">Update</button>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default EditService;
